module.exports = __webpack_public_path__ + "static/img/empty.e3036076.png";